// extracted by mini-css-extract-plugin
module.exports = {"expandibleContainer":"Expansion_expandibleContainer__jdvPM","expansionTitle":"Expansion_expansionTitle__pVruy","button":"Expansion_button__OFzpS"};